import axios from "axios";
import { ADMIN_TOKEN_KEY } from "./authApi";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EVENT_SLUG = "davangere-members-day-2026";

function auth() {
  const t = localStorage.getItem(ADMIN_TOKEN_KEY);
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export const alertsApi = {
  list: (limit = 40) => axios.get(`${API}/admin/alerts`, { params: { event_slug: EVENT_SLUG, limit }, headers: auth() }).then((r) => r.data),
  emit: (payload) => axios.post(`${API}/admin/alerts`, { event_slug: EVENT_SLUG, ...payload }, { headers: auth() }).then((r) => r.data),
  seen: (id) => axios.post(`${API}/admin/alerts/${id}/seen`, {}, { headers: auth() }).then((r) => r.data),
  seenAll: () => axios.post(`${API}/admin/alerts/seen-all?event_slug=${EVENT_SLUG}`, {}, { headers: auth() }).then((r) => r.data),
};
